import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router does not reset scroll position on navigation the way a real
 * page load does — without this, clicking a link while scrolled down on the
 * previous page leaves the new page scrolled down too. Skips when the URL
 * carries a hash (an in-page anchor link), letting the browser's native
 * scroll-to-anchor behaviour run instead.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
